import { Clock, CreditCard, FileText } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const features = [{
  icon: Clock,
  title: "Net 30 Terms",
  description: "Approved commercial partners receive standard Net 30 payment terms to support operational cash flow and inventory management."
}, {
  icon: FileText,
  title: "Digital Invoicing",
  description: "Receive automated, detailed digital invoices directly to your accounts payable department upon fulfillment of each order."
}, {
  icon: CreditCard,
  title: "Flexible Payments",
  description: "Settle accounts via ACH, wire transfer, or corporate credit card through our secure, dedicated commercial portal."
}];
export default function NetTerms() {
  return <section id="net-termsinvoicing" className="w-full py-24 md:py-40 bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute left-8 md:left-16 top-0 bottom-0 w-[1px] bg-border/60 hidden md:block" />

      <div className="max-w-[1440px] mx-auto px-6 md:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center">

          {}
          <div className="lg:col-span-6 order-2 lg:order-1">
            <span className="font-mono text-[clamp(0.75rem,1vw,0.875rem)] font-medium tracking-[0.25em] uppercase text-muted-foreground mb-6 block">
              03 // Billing & Terms
            </span>
            <h2 className="font-serif text-[clamp(2rem,5vw,3.5rem)] font-semibold tracking-[-0.02em] leading-[1.1] text-foreground mb-8">
              Flexible Terms for the Long Haul.
            </h2>
            <p className="font-sans text-[clamp(1.125rem,1.5vw,1.25rem)] leading-[1.6] text-foreground/80 mb-12 max-w-2xl">
              We understand the demands of the culinary and retail industries. The Miss Yvonne offers streamlined invoicing and flexible payment terms designed to keep your galley running smoothly while we handle the catch.
            </p>

            <div className="space-y-8 mb-12">
              {features.map((feature, i) => <div key={i} data-index={i} className="flex gap-6 items-start">
                  <div className="shrink-0 w-12 h-12 rounded-lg border border-border flex items-center justify-center text-primary bg-card shadow-sm">
                    <feature.icon className="w-5 h-5 stroke-[1.5]" />
                  </div>
                  <div>
                    <h3 className="font-serif text-xl font-semibold text-foreground mb-2">
                      {feature.title}
                    </h3>
                    <p className="font-sans text-base text-foreground/70 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <Button asChild size="lg" className="bg-secondary text-secondary-foreground font-mono uppercase tracking-widest px-10 py-6 hover:bg-foreground hover:text-background transition-colors duration-150">
              <Link to="/ContactPage">Apply for Terms</Link>
            </Button>
          </div>

          {}
          <div className="lg:col-span-6 order-1 lg:order-2 relative">
            <div className="relative w-full aspect-[4/5] lg:aspect-[3/4] border border-border bg-muted p-3 md:p-4 shadow-2xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/commercial_invoicing_ledger.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/commercial_invoicing_ledger.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/commercial_invoicing_ledger.webp-wvc-sizes" alt="Vintage maritime ledger and commercial invoicing documents" className="w-full h-full object-cover" loading="lazy" />
              {}
              <div className="absolute -right-16 top-1/2 -translate-y-1/2 rotate-90 font-mono text-xs tracking-widest text-muted-foreground hidden xl:block whitespace-nowrap">
                30° 24' 42" N / 88° 49' 42" W
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}